import { useMemo } from "react";
import PropTypes from "prop-types";

const WealthRM = ({
  className = "",
  Job_Opening,
  Location,
  wealthRMJustifyContent,
  mumbaiPuneWidth,
  mumbaiPuneDisplay,
  mumbaiPuneHeight,
}) => {
  const wealthRMStyle = useMemo(() => {
    return {
      justifyContent: wealthRMJustifyContent,
    };
  }, [wealthRMJustifyContent]);

  const locationStyle = useMemo(() => {
    return {
      width: mumbaiPuneWidth,
      display: mumbaiPuneDisplay,
      height: mumbaiPuneHeight,
    };
  }, [mumbaiPuneWidth, mumbaiPuneDisplay, mumbaiPuneHeight]);

  return (
    <div
      className={`rounded-6xl bg-gainsboro-200 h-[250px] lg:h-[180px] w-full flex flex-col lg:flex-row justify-between p-8 box-border text-darkslateblue font-istok-web ${className}`}
      style={wealthRMStyle}
    >
      <div className="flex flex-col gap-2 lg:h-full lg:justify-between">
        <b className="relative text-6xl lg:text-21xl leading-[100%] uppercase [text-shadow:0px_4px_4px_rgba(0,_0,_0,_0)]">
          {Job_Opening}
        </b>

        <div className="flex flex-row items-end justify-start gap-3 text-6xl text-dimgray">
          <img
            className="relative w-6 object-contain"
            // style={{ marginLeft: "140px" }}
            alt=""
            src="/loca-6@2x.png"
          />
          <div
            className="relative leading-[130%] capitalize [text-shadow:0px_4px_4px_rgba(0,_0,_0,_0)]"
            style={locationStyle}
          >
            {Location}
          </div>
        </div>
      </div>

      <div className="rounded-6xl shadow-[0px_4px_4px_rgba(0,_0,_0,_0.25)] bg-gray-100 flex items-center justify-center py-4 px-[22px] box-border text-deepskyblue-200">
        <a
          // className="w-[199px] relative [text-decoration:underline] leading-[130%] capitalize text-[inherit] inline-block h-10 shrink-0 [text-shadow:0px_4px_4px_rgba(0,_0,_0,_0)]"
          className="relative flex items-center text-13xl [text-decoration:underline] text-[inherit] [text-shadow:0px_4px_4px_rgba(0,_0,_0,_0)] h-10"
          href="https://docs.google.com/forms/d/e/1FAIpQLSd6VupdVVNOOozgXVoCPSgKQLbFvvwi818l_5kx1wbEV36WLw/viewform?usp=header"
          target="_blank"
        >
          Apply Now
        </a>
      </div>
    </div>
  );
};

WealthRM.propTypes = {
  className: PropTypes.string,
  Job_Opening: PropTypes.string,
  Location: PropTypes.string,

  /** Style props */
  wealthRMJustifyContent: PropTypes.string,
  mumbaiPuneWidth: PropTypes.string,
  mumbaiPuneDisplay: PropTypes.string,
  mumbaiPuneHeight: PropTypes.string,
};

export default WealthRM;
